import { Paragraph } from "@twilio-paste/core/paragraph";
import {
  AvatarWrapper,
  CardRequestPhoneNumber,
} from "@twiliointernal/e2-commons-shared-ui";
import { MessageBlockRole } from "@twiliointernal/e2-commons-shared-definitions";
import { copy, types } from "./definitions";
import { Box } from "@twilio-paste/core/box";
import { Badge } from "@twilio-paste/core/badge";
import { SuccessIcon } from "@twilio-paste/icons/esm/SuccessIcon";
import { ReactElement } from "react";

const CallbackRequestView = ({
  loading,
  phoneNumber,
  onSubmit,
  onClose,
}: types.CallbackRequestViewProps) => {
  const renderNotificationForm = (): ReactElement => (
    <CardRequestPhoneNumber
      menuPlacement="top-start"
      description={copy.action.formDescription}
      loading={loading}
      onSubmit={onSubmit}
      onCancel={onClose}
    />
  );

  const renderNotificationRequested = (): ReactElement => (
    <>
      <Paragraph>{copy.action.notificationRequested(phoneNumber)}</Paragraph>
      <Box
        display="flex"
        columnGap="space80"
        marginBottom="space60"
        paddingY="space30"
      >
        <Badge as="span" variant="success">
          <SuccessIcon decorative />
          {copy.action.requestSubmittedCTA}
        </Badge>
      </Box>
    </>
  );

  return (
    <Box marginTop="space60">
      <AvatarWrapper role={MessageBlockRole.Assistant}>
        {phoneNumber && phoneNumber.length > 10
          ? renderNotificationRequested()
          : renderNotificationForm()}
      </AvatarWrapper>
    </Box>
  );
};

export default CallbackRequestView;
